import React from 'react'
import { ScreenReaderOnly } from '@moonpig/launchpad-components'
import { Suggestion } from '../../ChatMessages/types'
import { useLocaleText } from '../../locale'
import {
  StyledIconSystemInformation,
  StyledSuggestionsContainer,
  StyledSuggestionTitleFlex,
  StyledSuggestionTitleText,
  SuggestionsIntroMessageStyledButton,
  SuggestionsMessageStyledFlex,
} from './styled'

export const SuggestionsIntroMessage = ({
  title,
  suggestions,
  suggestionClickHandler,
  id,
}: {
  title?: string
  suggestions: string[]
  suggestionClickHandler: (
    suggestion: Suggestion,
    suggestionOptions: number,
  ) => void
  id: number
}) => {
  const t = useLocaleText()
  const labelId = `chat-suggestions-label-${id}`
  const titleId = `chat-suggestions-title-${id}`
  const descriptionId = `chat-suggestions-description-${id}`
  const hasSelectableSuggestions = suggestions.length > 0

  return (
    <StyledSuggestionsContainer
      aria-labelledby={`${labelId} ${titleId}`}
      aria-describedby={hasSelectableSuggestions ? descriptionId : undefined}
      data-testid="chat-suggestions-container"
      role="article"
    >
      <ScreenReaderOnly id={labelId}>
        {t('concierge_chat.screen_reader_assistant_label')}
      </ScreenReaderOnly>
      <StyledSuggestionTitleFlex>
        <StyledSuggestionTitleText
          data-testid="chat-suggestions-title"
          id={titleId}
        >
          {title || t('concierge_chat.quick_prompts_title')}
        </StyledSuggestionTitleText>
        <StyledIconSystemInformation />
      </StyledSuggestionTitleFlex>
      {hasSelectableSuggestions && (
        <ScreenReaderOnly id={descriptionId}>
          {t('concierge_chat.suggestions_screen_reader_hint')}
        </ScreenReaderOnly>
      )}

      <SuggestionsMessageStyledFlex data-testid="chat-suggestions-options-container">
        {suggestions.map((suggestion, suggestionId, suggestionOptions) => (
          <SuggestionsIntroMessageStyledButton
            key={`suggestion-intro-${suggestion.replace(/\s/g, '-')}`}
            onClick={() =>
              suggestionClickHandler(
                {
                  text: suggestion,
                  id: suggestionId + 1,
                  source: 'intro',
                },
                suggestionOptions.length,
              )
            }
          >
            {suggestion}
          </SuggestionsIntroMessageStyledButton>
        ))}
      </SuggestionsMessageStyledFlex>
    </StyledSuggestionsContainer>
  )
}
